import { createRouter, createWebHistory } from 'vue-router'
import { useAuth } from '@/composables/useAuth'
import HomepageLayout from '@/layouts/HomepageLayout.vue'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import TotalPackagePage from '@/pages/TotalPackagePage.vue'
import LegalOverview from '@/views/LegalOverview.vue'
import ConsultationConfirmedView from '@/views/ConsultationConfirmedView.vue'
import TermsAndConditionsView from '@/views/TermsAndConditionsView.vue'
import PrivacyPolicyView from '@/views/PrivacyPolicyView.vue'
import CookiePolicyView from '@/views/CookiePolicyView.vue'
import ServiceLevelAgreementView from '@/views/ServiceLevelAgreementView.vue'
import LegalPageLayout from '@/layouts/LegalPageLayout.vue'
import AcceptableUsePolicyView from '@/views/AcceptableUsePolicyView.vue'
import AboutContactView from '@/views/AboutContactView.vue'
import DashboardView from '@/views/DashboardView.vue'
import MinimalLayout from '@/layouts/MinimalLayout.vue'
import CheckoutSummaryView from '@/views/CheckoutSummaryView.vue'
import BlueprintHundredPage from '@/pages/BlueprintHundredPage.vue'
import OrderTotalPackage from '@/pages/OrderTotalPackage.vue'
import GetStartedPage from '@/pages/GetStartedPage.vue'
import ScheduleConsultationPage from '@/pages/ScheduleConsultationPage.vue'
import EmailConfigPage from '@/pages/EmailConfigPage.vue'
import IosTutorialPage from '@/pages/IosTutorialPage.vue'
import GmailTutorialPage from '@/pages/GmailTutorialPage.vue'
import AdminOrderLinkGenerator from '@/pages/AdminOrderLinkGenerator.vue'
import CheckoutLinkGenerator from '@/pages/CheckoutLinkGenerator.vue'
import DashboardHome from '@/views/DashboardHome.vue'
import ThankYouView from '@/views/ThankYouView.vue'
const routes = [
  {
    path: '/',
    component: HomepageLayout,
    children: [
      { path: '', name: 'Home', component: TotalPackagePage },
    ],
  }, {
    path: '/',
    component: DefaultLayout,
    children: [
      { path: 'consultation-confirmed', name: 'Consultation Confirmed', component: ConsultationConfirmedView },
      { path: 'about', name: 'AboutContact', component: AboutContactView },
      { path: 'blueprint100', name: "Blueprint 100", component: BlueprintHundredPage },
      { path: 'emailsetup', name: 'Email Setup', component: EmailConfigPage },
      { path: 'emailsetup/ios-tutorial', name: 'iOS Mail Tutorial', component: IosTutorialPage },
      { path: 'emailsetup/gmail-tutorial', name: 'Gmail Tutorial', component: GmailTutorialPage },
      { path: 'thank-you', name: 'Thank You', component: ThankYouView },
    ]
  },
  {
    path: '/',
    component: LegalPageLayout,
    children: [
      {
        path: 'legal/overview',
        name: 'Legal Overview',
        component: LegalOverview,
        meta: { titleKey: 'legalOverview.title', subtitleKey: 'legalOverview.subtitle' }
      },
      {
        path: 'legal/terms-and-conditions',
        name: 'Terms and Conditions',
        component: TermsAndConditionsView,
        meta: { titleKey: 'terms.title', subtitleKey: 'terms.subtitle' }
      },
      {
        path: 'legal/privacy-policy',
        name: 'Privacy Policy',
        component: PrivacyPolicyView,
        meta: { titleKey: 'privacy.title', subtitleKey: 'privacy.subtitle' }
      },
      {
        path: 'legal/cookie-policy',
        name: 'Cookie Policy',
        component: CookiePolicyView,
        meta: { titleKey: 'cookie.title', subtitleKey: 'cookie.subtitle' }
      },
      {
        path: 'legal/sla',
        name: 'Service Level Agreement',
        component: ServiceLevelAgreementView,
        meta: { titleKey: 'sla.title', subtitleKey: 'sla.subtitle' }
      },
      {
        path: 'legal/aup',
        name: 'Acceptable Use Policy',
        component: AcceptableUsePolicyView,
        meta: { titleKey: 'aup.title', subtitleKey: 'aup.subtitle' }
      }
    ]
  },
  {
    path: '/',
    component: MinimalLayout,
    children: [
      { path: "total-package/order", name: "Order Total Package", component: OrderTotalPackage, meta: { hideFooter: false }, },
      { path: 'get-started', name: 'Get Started', component: GetStartedPage, meta: { hideFooter: true }, },
      { path: 'contact', name: 'Contact', component: ScheduleConsultationPage, meta: { hideFooter: false }, },
      { path: 'checkout', name: 'checkout', component: CheckoutSummaryView, meta: { hideFooter: true }, },
    ],
  },
  {
    path: '/dashboard',
    component: DashboardView,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: DashboardHome,
      },
      {
        path: 'order-link-generator',
        name: 'Order Link Generator',
        component: AdminOrderLinkGenerator,
      },
      {
        path: 'checkout-link-generator',
        name: 'Checkout Link Generator',
        component: CheckoutLinkGenerator,
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // If the user used the browser back/forward buttons, preserve saved position:
    if (savedPosition) {
      return savedPosition;
    }
    // Otherwise always scroll to top
    return { left: 0, top: 0 };
  },
});

let userFetched = false;

router.beforeEach((to, from, next) => {
  const { fetchUser, isAuthenticated } = useAuth();

  if (!userFetched) {
    userFetched = true;

    // Only block for protected routes
    if (to.meta.requiresAuth) {
      fetchUser()
        .then(() => {
          if (!isAuthenticated()) {
            return next({ name: 'Login', query: { redirect: to.fullPath } });
          }
          next();
        })
        .catch(() => next({ name: 'Login' }));
    } else {
      // For public routes, fire and forget
      Promise.resolve().then(() => fetchUser().catch(() => { }));
      next();
    }
  } else {
    if (to.meta.requiresAuth && !isAuthenticated()) {
      return next({ name: 'Login' });
    }
    next();
  }
});



export default router